export const DEFAULT_DIVIDER_PICTURE_SUBTITLE =
  "Visit the first digital conference.";
export const DEFAULT_DIVIDER_PICTURE_DESCRIPTION =
  "Over three days of unscripted interviews and interactive workshops, attendees with an eye on emerging trends will hear from and collaborate with entrepreneurs, artists, athletes, scientists and thinkers for a first look at the seismic shifts occurring in the way we live, work and play.";
export const DEFAULT_DIVIDER_PICTURE_CTA_TEXT = "Register";
